class VideoBlock extends HTMLElement {
  constructor() {
    super();

    this.player = this.querySelector('.video-block__player');
    this.header_video = this.querySelector('.video-block__player[data-header-video]');
    this.overlay = this.querySelector('.video-block__overlay');
    this.small_button = this.querySelector('.video-block__small-button');

    document.addEventListener('DOMContentLoaded', () => {
      if(this.header_video && window.innerWidth < 991) return
      this.load(this.player);
      this.player.autoplay ? this.player.play() : this.player.pause();
      this.small_button?.classList.add('is-visible')
    });

    this.overlay?.addEventListener('click', (e) => {
      e.preventDefault();
      this.load(this.player);
      this.player.paused ? this.player.play() : this.player.pause()
    });

    this.small_button?.addEventListener('click', (e) => {
      e.preventDefault();
      this.player.paused ? this.player.play() : this.player.pause()
    });

    this.player?.addEventListener('play', () => {
      this.overlay && this.overlay.classList.remove('visible');
      this.small_button.querySelector('.pause').style.display = "initial"
      this.small_button.querySelector('.play').style.display = "none"
      this.small_button.setAttribute('aria-label', this.small_button.dataset.pause)
    });

    this.player?.addEventListener('pause', () => {
      if (this.player.readyState > this.player.HAVE_FUTURE_DATA) {
        this.overlay && this.overlay.classList.add('visible');
        this.small_button.querySelector('.pause').style.display = "none"
        this.small_button.querySelector('.play').style.display = "initial"
        this.small_button.setAttribute('aria-label', this.small_button.dataset.play)
      }
    });
  };

  load(player) {
    if (player && player.readyState !== 4) {
      player.src = player.dataset.src;
      player.load();
    }
  };

}
customElements.define('video-block', VideoBlock)